import React, {useState} from 'react';
import styled from 'styled-components';
import {useFormik} from 'formik';
import {useAuth} from '../context/AuthContext';
import server from '../global/server';
import useHandleErrors from '../hooks/useHandleErrors';
import Typography from '@mui/material/Typography';
import LoadingButton from '@mui/lab/LoadingButton';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import {useNavigate} from 'react-router-dom';
import {useCookies} from 'react-cookie';
import {sleep} from '../global/helpers';
import {Box, Button, Dialog, DialogContent, DialogTitle, Divider} from '@mui/material';
import logo from '../assets/logo.png';
import LostPassForm from './LostPassForm';

const Authentication = props => {
    const {Login} = useAuth();
    const [cookies, setCookies] = useCookies(['user', 'token']);
    const [hasError, setError] = useState();
    const [dialog, setDialog] = useState(false)
    useHandleErrors(hasError);

    const {values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting} =
        useFormik({
            initialValues: {username: '14926394000119', password: '123456'},
            onSubmit: async (values, {setSubmitting}) => {
                try {
                    setSubmitting(true);
                    const {data} = await server.post('auth', values);
                    Login(data.data.user, data.data.token);
                    sleep(1000);
                    setSubmitting(false);
                } catch (error) {
                    setSubmitting(false);
                    setError(error);
                }
            },
        });

    return (
        <PanelAuth>
            <div>
                {/* <Logo>
                    <img width={250} src={logo}sx={{ marginBottom: 20 }} />
                </Logo> */}
                <BoxAuth>
                    <form onSubmit={handleSubmit}>
                        <Grid container direction="column" gap={2}>
                            <Grid item sx={{textAlign: 'center'}}>
                                <Box
                                    sx={{width: 150, marginBottom: 2}}
                                    component="img"
                                    src={logo}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Title>
                                    <Typography variant="h6">Painel do cliente </Typography>
                                </Title>
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    variant="outlined"
                                    fullWidth
                                    required
                                    label="E-mail"
                                    type="text"
                                    name="username"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.username}
                                    //disabled={isOffline}
                                    error={Boolean(errors.username)}
                                    helperText={errors.username}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    variant="outlined"
                                    fullWidth
                                    label="Senha"
                                    type="password"
                                    name="password"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.password}
                                    error={Boolean(errors.password)}
                                    helperText={errors.password}
                                    //disabled={isOffline}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <LoadingButton
                                    type="submit"
                                    fullWidth
                                    loading={isSubmitting}
                                    variant="contained"
                                    disabled={
                                        !(values.username && values.password) || isSubmitting
                                    }>
                                    Entrar
                                </LoadingButton>
                            </Grid>
                            <Grid item xs={12}>
                                <Button fullWidth onClick={e=>setDialog(true)}>Recuperar senha</Button>
                            </Grid>
                        </Grid>
                    </form>
                </BoxAuth>
            </div>
            <Dialog open={dialog} onClose={e=>setDialog(false)} fullWidth maxWidth="xs">
                <DialogTitle>Recuperar senha</DialogTitle>
                <Divider/>
                <LostPassForm />
            </Dialog>
        </PanelAuth>
    );
};

export default Authentication;

const PanelAuth = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #eee;
`;

const BoxAuth = styled(Grid)`
    border: 1px solid #ccc;
    border-radius: 1rem;
    padding: 2rem;
    width: 350px;
    background: white;
`;

const Title = styled.div`
    text-align: center;
    margin-bottom: 20px;
`;

const BoxAuthContainer = styled.div`
    padding: 1px;
`;
